import type { ReactNode } from 'react';
import React, { createContext, useContext } from 'react';
import { useComplianceEmployee } from '~/shared/hooks';
import { EmployeeContextType } from '../types/employee-context.types';

const EmployeeContext = createContext<EmployeeContextType | undefined>(undefined);

interface EmployeeContextProviderProps {
    children: ReactNode;
}

export const EmployeeContextProvider: React.FC<EmployeeContextProviderProps> = ({
    children
}) => {
    const employeeContextValue = useComplianceEmployee();

    return (
        <EmployeeContext.Provider value={employeeContextValue}>
            {children}
        </EmployeeContext.Provider>
    );
};

export const useEmployeeContext = () => {
    const context = useContext(EmployeeContext);
    if (context === undefined) {
        throw new Error('useEmployeeContext must be used within EmployeeContextProvider');
    }
    return context;
};
